<div class="modal-content">
  <cluster-form
    [isEditMode]="isEditMode"
    [data]="item"
    (processCompleted)="onProcessCompleted($event)"></cluster-form>
</div>
